/**
 * YUMIX — Locale / Unit helpers (frontend mirror of backend/services/locale_units.py).
 * Used by Settings and anywhere else that needs to auto-switch display units.
 */

export const IMPERIAL_COUNTRIES = new Set(['US', 'LR', 'MM']);
export const NA_REFERENCE_COUNTRIES = new Set(['CA', 'US']);

export const defaultUnitSystem = (countryIso) => {
  if (!countryIso) return 'metric';
  return IMPERIAL_COUNTRIES.has(String(countryIso).toUpperCase()) ? 'imperial' : 'metric';
};

export const needsComplianceNotice = (countryIso) => {
  if (!countryIso) return false;
  return !NA_REFERENCE_COUNTRIES.has(String(countryIso).toUpperCase());
};

// Conversion helpers — keep ml / g as internal base, only convert for display.
export const mlToFlOz = (ml) => ml / 29.5735;
export const flOzToMl = (oz) => oz * 29.5735;
export const kgToLb = (kg) => kg / 0.45359237;
export const lbToKg = (lb) => lb * 0.45359237;
